import React from 'react';
import { ArrowDownward } from '@mui/icons-material';
import type { WorkoutPlanPayload } from '../../../../data-access/api/science/openapi/api';
import '../richContext.scss';

type WorkoutPlanExercise = NonNullable<WorkoutPlanPayload['exercises']>[number];

type Props = {
  exercises: WorkoutPlanExercise[];
};

const GymWorkoutPlanContent: React.FC<Props> = ({ exercises }) => {
  const gymExercises = exercises.filter((ex) => typeof (ex as any)?.name === 'string');
  if (gymExercises.length === 0) return null;

  return (
    <div className="rc-gym-exercise-list">
      {gymExercises.map((ex, idx) => {
        const name = typeof (ex as any).name === 'string' ? String((ex as any).name).trim() : '';
        if (!name) return null;
        const sets = typeof (ex as any).sets === 'number' ? (ex as any).sets : undefined;
        const reps = typeof (ex as any).reps === 'number' ? (ex as any).reps : undefined;
        const restSec = typeof (ex as any).rest_sec === 'number' ? (ex as any).rest_sec : undefined;
        const durationSec =
          typeof (ex as any).duration_sec === 'number' ? (ex as any).duration_sec : undefined;
        const durationMin =
          typeof durationSec === 'number' && Number.isFinite(durationSec)
            ? Math.max(0, Math.round(durationSec / 60))
            : undefined;
        const repsOrDuration =
          typeof reps === 'number'
            ? `${reps} Reps`
            : typeof durationMin === 'number' && durationMin > 0
              ? `${durationMin} min`
              : null;
        const setPillLabel = repsOrDuration
          ? typeof sets === 'number'
            ? `${sets} x ${repsOrDuration}`
            : repsOrDuration
          : typeof sets === 'number'
            ? `${sets} Sets`
            : null;

        return (
          <React.Fragment key={`${name}_${idx}`}>
            <div className="rc-gym-exercise-card">
              <span className="rc-gym-exercise-name">{name}</span>
              {!!setPillLabel && (
                <span className="rc-gym-set-pill">
                  <span className="rc-gym-set-pill-text">{setPillLabel}</span>
                </span>
              )}
            </div>
            {typeof restSec === 'number' && restSec > 0 && idx < gymExercises.length - 1 && (
              <div className="rc-gym-rest-row">
                <span className="rc-gym-rest-chip">
                  <ArrowDownward className="rc-gym-rest-chip-icon" />
                  <span className="rc-gym-rest-chip-text">{restSec}s Rest</span>
                </span>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default GymWorkoutPlanContent;
